import React from 'react';
import { GroupHeadingProps } from 'react-select';

export const MacroAutocompleteGroupHeading = ({ children, data: { label } }: GroupHeadingProps) => {
  if (!label) {
    return null;
  }

  return <div className="macro-autocomplete-g_heading">{children}</div>;
};
